import { render, staticRenderFns } from "./SocState.vue?vue&type=template&id=6f2775ea&scoped=true&"
import script from "./SocState.vue?vue&type=script&lang=js&"
export * from "./SocState.vue?vue&type=script&lang=js&"
import style0 from "./SocState.vue?vue&type=style&index=0&id=6f2775ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2775ea",
  null
  
)

export default component.exports